import { useAuthStore } from '@/stores/auth'
import { resolvePageSize } from '@/config/pagination'

/** Resolve the current user's preferred rows-per-page for list requests. */
export function getRowsPerPage(): number {
  return resolvePageSize(useAuthStore().user?.rows_per_page)
}
